// extracted by mini-css-extract-plugin
module.exports = {"container":"InstructionCard_container__34WXy","title":"InstructionCard_title__2iGEC","content":"InstructionCard_content__jveH1"};